/* Textos fijos del tema (los que no salen del editor): diccionario ES -> it, fr, pt, en */
(function () {
  var lang = (document.documentElement.lang || 'es').toLowerCase().slice(0, 2);
  var idx = { it: 0, fr: 1, pt: 2, en: 3 }[lang];
  if (idx === undefined) return;
  var D = {
    'Total': ['Totale', 'Total', 'Total', 'Total'],
    'Pago seguro con': ['Paga in sicurezza con', 'Paiement sécurisé avec', 'Pagamento seguro com', 'Secure payment with'],
    'Saltar al contenido': ['Vai al contenuto', 'Aller au contenu', 'Saltar para o conteúdo', 'Skip to content'],
    'Esta opción no está disponible ahora mismo.': ['Questa opzione non è disponibile al momento.', "Cette option n'est pas disponible pour le moment.", 'Esta opção não está disponível neste momento.', 'This option is not available right now.'],
    'No se pudo añadir': ['Impossibile aggiungere', "Impossible d'ajouter", 'Não foi possível adicionar', 'Could not add'],
    'Abrir carrito': ['Apri il carrello', 'Ouvrir le panier', 'Abrir o carrinho', 'Open cart'],
    'Cerrar carrito': ['Chiudi il carrello', 'Fermer le panier', 'Fechar o carrinho', 'Close cart'],
    'Tu carrito': ['Il tuo carrello', 'Ton panier', 'O teu carrinho', 'Your cart'],
    'Tu carrito está vacío.': ['Il tuo carrello è vuoto.', 'Ton panier est vide.', 'O teu carrinho está vazio.', 'Your cart is empty.'],
    'Seguir comprando': ['Continua lo shopping', 'Continuer mes achats', 'Continuar a comprar', 'Continue shopping'],
    'Subtotal': ['Subtotale', 'Sous-total', 'Subtotal', 'Subtotal'],
    'Impuestos incluidos. El envío se indica antes de pagar.': ['Tasse incluse. La spedizione è indicata prima del pagamento.', 'Taxes incluses. La livraison est indiquée avant le paiement.', 'Impostos incluídos. O envio é indicado antes de pagar.', 'Taxes included. Shipping is shown before you pay.'],
    'Finalizar compra': ["Concludi l'acquisto", 'Finaliser la commande', 'Finalizar compra', 'Checkout'],
    'Menos': ['Meno', 'Moins', 'Menos', 'Less'],
    'Más': ['Più', 'Plus', 'Mais', 'More'],
    'Quitar': ['Rimuovi', 'Retirer', 'Remover', 'Remove'],
    'Foto anterior': ['Foto precedente', 'Photo précédente', 'Foto anterior', 'Previous photo'],
    'Foto siguiente': ['Foto successiva', 'Photo suivante', 'Foto seguinte', 'Next photo'],
    'Incluido con el pack doble': ['Incluso nel pack doppio', 'Inclus avec le pack double', 'Incluído no pack duplo', 'Included with the double pack'],
    'OFERTA ÚNICA': ['OFFERTA UNICA', 'OFFRE UNIQUE', 'OFERTA ÚNICA', 'ONE-TIME OFFER'],
    'Solo aquí y ahora: si la omites, no podrás volver a verla.': ['Solo qui e ora: se la salti, non potrai più vederla.', "Seulement ici et maintenant : si tu l'ignores, tu ne pourras plus la revoir.", 'Só aqui e agora: se a ignorares, não a poderás voltar a ver.', "Only here and now: if you skip it, you won't see it again."],
    'Último paso antes de pagar': ['Ultimo passo prima di pagare', 'Dernière étape avant de payer', 'Último passo antes de pagar', 'Last step before paying'],
    'Llévate 2 aceites aromáticos por solo 14,99 €': ['Porta a casa 2 oli aromatici per soli 14,99 €', 'Emporte 2 huiles aromatiques pour seulement 14,99 €', 'Leva 2 óleos aromáticos por apenas 14,99 €', 'Get 2 aromatic oils for just €14.99'],
    'Elige tus dos aromas favoritos y los añadimos a tu pedido.': ['Scegli i tuoi due aromi preferiti e li aggiungiamo al tuo ordine.', 'Choisis tes deux parfums préférés et nous les ajoutons à ta commande.', 'Escolhe os teus dois aromas favoritos e adicionamo-los à tua encomenda.', "Choose your two favourite scents and we'll add them to your order."],
    'Aceite 1': ['Olio 1', 'Huile 1', 'Óleo 1', 'Oil 1'],
    'Aceite 2': ['Olio 2', 'Huile 2', 'Óleo 2', 'Oil 2'],
    '2 aceites': ['2 oli', '2 huiles', '2 óleos', '2 oils'],
    'Añadir a mi pedido y pagar': ['Aggiungi al mio ordine e paga', 'Ajouter à ma commande et payer', 'Adicionar à minha encomenda e pagar', 'Add to my order and pay'],
    'No, gracias, omitir y pagar': ['No, grazie, salta e paga', 'Non merci, passer et payer', 'Não, obrigada, saltar e pagar', 'No thanks, skip and pay'],
    'Frascos de 10 ml. Uso externo y como aroma. Se envían por separado y pueden llegar en otra fecha.': ["Flaconi da 10 ml. Uso esterno e come aroma. Vengono spediti separatamente e possono arrivare in un'altra data.", 'Flacons de 10 ml. Usage externe et comme arôme. Expédiés séparément, ils peuvent arriver à une autre date.', 'Frascos de 10 ml. Uso externo e como aroma. São enviados em separado e podem chegar noutra data.', '10 ml bottles. For external use and as a scent. Shipped separately and may arrive on a different date.'],
    'Elige los dos aromas.': ['Scegli i due aromi.', 'Choisis les deux parfums.', 'Escolhe os dois aromas.', 'Choose both scents.']
  };
  var COLORS = { 'Rosa': ['Rosa', 'Rose', 'Rosa', 'Pink'], 'Blanco': ['Bianco', 'Blanc', 'Branco', 'White'] };
  var PREFIX = [
    ['Lo quiero', ['Lo voglio', 'Je le veux', 'Quero', 'I want it']],
    ['Descuentos aplicados:', ['Sconti applicati:', 'Remises appliquées :', 'Descontos aplicados:', 'Discounts applied:']],
    ['Regalo:', ['Regalo:', 'Cadeau :', 'Oferta:', 'Gift:']]
  ];
  var NOTE = /^Uno solo cuesta (.+): por solo 5,00 € más tienes el segundo\.$/;
  var NOTE_T = ['Uno solo costa $1: per soli 5,00 € in più hai il secondo.', 'Un seul coûte $1 : pour seulement 5,00 € de plus, tu as le deuxième.', 'Um só custa $1: por apenas 5,00 € a mais tens o segundo.', 'One alone costs $1: for just €5.00 more you get the second.'];
  function tr(s, inColor) {
    var t = s.trim();
    if (!t) return s;
    var r = null;
    if (inColor && COLORS[t]) r = COLORS[t][idx];
    else if (D[t]) r = D[t][idx];
    else {
      var m = NOTE.exec(t);
      if (m) r = NOTE_T[idx].replace('$1', m[1]);
      else for (var i = 0; i < PREFIX.length; i++) if (t.indexOf(PREFIX[i][0]) === 0) { r = PREFIX[i][1][idx] + t.slice(PREFIX[i][0].length); break; }
    }
    return r === null ? s : s.replace(t, r);
  }
  function node(n) {
    var v = n.nodeValue; if (!v || !v.trim()) return;
    var p = n.parentNode; if (!p || /^(SCRIPT|STYLE)$/.test(p.nodeName)) return;
    var r = tr(v, !!(p.closest && p.closest('[data-color-name]')));
    if (r !== v) n.nodeValue = r;
  }
  function attrs(el) {
    ['aria-label', 'title'].forEach(function (a) {
      var v = el.getAttribute && el.getAttribute(a);
      if (v) { var r = tr(v, !!(el.closest && el.closest('.bb-dot'))); if (r !== v) el.setAttribute(a, r); }
    });
  }
  function walk(root) {
    if (root.nodeType === 3) return node(root);
    if (root.nodeType !== 1) return;
    attrs(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(node);
    [].forEach.call(root.querySelectorAll('[aria-label],[title]'), attrs);
  }
  function start() {
    walk(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'characterData') node(m.target);
        else [].forEach.call(m.addedNodes, walk);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();